import { render, staticRenderFns } from "./Inquiries.vue?vue&type=template&id=011b7f1a"
import script from "./Inquiries.vue?vue&type=script&lang=ts"
export * from "./Inquiries.vue?vue&type=script&lang=ts"
import style0 from "./Inquiries.vue?vue&type=style&index=0&id=011b7f1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports